<mat-form-field floatLabel="always">
    <mat-chip-listbox
        #adGroupChipList
        [formControl]="TagControl"
        [selectable]="selectable"
    >
        <mat-chip
            *ngFor="let group of selectedGroups"
            [removable]="removable"
            (removed)="remove(group)"
        >
            {{ group.displayName }}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input
            #adGroupPickerInput
            matInput
            [name]="Label"
            [placeholder]="Label"
            [formControl]="InputControl"
            [matAutocomplete]="auto"
            [matChipInputFor]="adGroupChipList"
        />
        <mat-icon matSuffix>search</mat-icon>
    </mat-chip-listbox>
    <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        autoActiveFirstOption
    >
        <mat-option *ngFor="let option of matches | async" [value]="option">
            {{ option.displayName }}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
